"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformTokenCreateBodyToJSON = exports.transformJSONToTokenCreateBody = void 0;

var _tokenCreateAuthorizationCodeBody = require("./token-create-authorization-code-body");

var _tokenCreateRefreshTokenBody = require("./token-create-refresh-token-body");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformJSONToTokenCreateBody = function transformJSONToTokenCreateBody(value) {
  switch (value.grant_type) {
    case 'authorization_code':
      return (0, _tokenCreateAuthorizationCodeBody.transformJSONToTokenCreateAuthorizationCodeBody)(value);

    case 'refresh_token':
      return (0, _tokenCreateRefreshTokenBody.transformJSONToTokenCreateRefreshTokenBody)(value);

    default:
      throw new Error("No variant of TokenCreateBody exists with 'grantType=".concat(value.grantType, "'"));
  }
};

exports.transformJSONToTokenCreateBody = transformJSONToTokenCreateBody;

var transformTokenCreateBodyToJSON = function transformTokenCreateBodyToJSON(value) {
  switch (value.grantType) {
    case 'authorization_code':
      return (0, _tokenCreateAuthorizationCodeBody.transformTokenCreateAuthorizationCodeBodyToJSON)(value);

    case 'refresh_token':
      return (0, _tokenCreateRefreshTokenBody.transformTokenCreateRefreshTokenBodyToJSON)(value);
  }
};
/**
 * @type TokenCreateBody
 * @export
 */


exports.transformTokenCreateBodyToJSON = transformTokenCreateBodyToJSON;